module.exports = __webpack_public_path__ + "static/img/pdf.28691201.png";